export default function(state={}, action){
  switch(action.type) {
      case 'GET_MEASURMENTS':
          return {...state, measurements: action.paylod}
      default:
          return state;
  }
}